// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Stat,
  StatLabel,
  StatNumber,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesProjectRow from "components/Tables/TablesProjectRow";
import TablesTableRow from "components/Tables/TablesTableRow";
import React, { useEffect, useState } from "react";
import { tablesProjectData, tablesTableData } from "variables/general";

function Tables() {
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const [todos, setTodos] = useState([]);
  const [todosnormal, setTodosnormal] = useState([]);

  const obtenertodos = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/vertodoswill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setTodos(result);
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenertodosnormal = () => {
    const data = {
      token: localStorage.getItem("token_royal"),
    };
    fetch(`${process.env.REACT_APP_API}/vertodosnormalwill`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          setTodosnormal(result);
          if (result.message) {
            if (result.message == "Access Denied") {
              window.location.href = "/#/auth/signin";
              window.location.reload();
            }
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenertoken = () => {
    const isAuthenticated = localStorage.getItem("token_royal");

    console.log(window.location.hash);
    if (!isAuthenticated) {
      window.location.href = "/#/auth/signin";
      window.location.reload();
    }
  };

  useEffect(() => {
    obtenertoken();
    obtenertodos();
    obtenertodosnormal();
  }, []);

  useEffect(() => {
    console.log(todos);
  }, [todos]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Confirmed Referrals
          </Text>
        </CardHeader>
        <CardBody>
          {todos.length == 0 ? (
            <div align="center" style={{ padding: "20px" }}>
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  No Referrals Confirmed
                </StatLabel>
              </Stat>
            </div>
          ) : (
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  <Th pl="0px" borderColor={borderColor} color="gray.400">
                    Name
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Location
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Status
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Registro
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {todos.map((row, index, arr) => {
                  return (
                    <>
                      <TablesTableRow
                        name={row.Nombres}
                        logo={row.ImagenBag}
                        subdomain={row.Estado}
                        domain={row.Pais}
                        status={row.Estatus}
                        date={row.Fecha}
                        isLast={index === arr.length - 1 ? true : false}
                        key={index}
                      />
                    </>
                  );
                })}
              </Tbody>
            </Table>
          )}
        </CardBody>
      </Card>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} mt="40px" pb="0px">
        <CardHeader p="6px 0px 22px 0px">
          <Text fontSize="xl" color={textColor} fontWeight="bold">
            Unconfirmed referrals
          </Text>
        </CardHeader>
        <CardBody>
          {todosnormal.length == 0 ? (
            <div align="center" style={{ padding: "20px" }}>
              <Stat me="auto">
                <StatLabel
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  No referrals registered
                </StatLabel>
              </Stat>
            </div>
          ) : (
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" pl="0px" color="gray.400">
                  <Th pl="0px" borderColor={borderColor} color="gray.400">
                    Name
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Location
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Status
                  </Th>
                  <Th borderColor={borderColor} color="gray.400">
                    Registro
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {todosnormal.map((row, index, arr) => {
                  return (
                    <>
                      <TablesTableRow
                        name={row.Nombres}
                        logo={row.ImagenBag}
                        subdomain={row.Estado}
                        domain={row.Pais}
                        status={row.Estatus}
                        date={row.Fecha}
                        isLast={index === arr.length - 1 ? true : false}
                        key={index}
                      />
                    </>
                  );
                })}
              </Tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default Tables;
